<template>
  <div v-if="pending || (!pending && !error)">
    <BasePreloader v-if="pending"/>

    <main v-else class="l-content">
      <article class="l-section preview_none for_blogpost">
        <div class="l-section-h i-cf">
          <div class="w-blog">
            <div class="w-blog-post-body">
              <h1 class="w-blog-post-title entry-title">{{ news.title }}</h1>
              <div class="w-blog-post-meta">
                <time class="w-blog-post-meta-date" :datetime="news.date | formatDate(true)">
                  {{ news.date | formatDate }}
                </time>
                <!--<span class="w-blog-post-meta-category">-->
                <!--  <a href="https://classic.com.ua/category/novyny/" rel="category tag">Новини</a>-->
                <!--</span>-->
                <!--<span class="w-blog-post-meta-author vcard author hidden">-->
                <!--  <a href="https://classic.com.ua/author/classic/" class="fn">Classic</a>-->
                <!--</span>-->
              </div>
            </div>
          </div>
        </div>
      </article>

      <section class="l-section">
        <div class="l-section-h i-cf" v-html="news.text" data-html/>
        <div class="l-section-h i-cf" v-if="news?.gallery?.images.length > 1">
          <div class="w-gallery type_default style_simple link_media">
            <div class="w-gallery-list">
              <a
                class="w-gallery-item order_1"
                v-for="photo of news?.gallery?.images"
                :key="photo.id"
                target="_blank"
                :href="photo.image"
                title="classic family"
              >
                <div class="w-gallery-item-img">
                  <img
                    width="900"
                    height="600"
                    :src="photo.image"
                    class="attachment-full size-full"
                    :alt="news.gallery.name"
                    sizes="(max-width: 900px) 100vw, 900px"
                  />
                </div>
              </a>
            </div>
          </div>
        </div>

        <div v-if="news.videoUrls !== ''" style="text-align: center">
          <iframe
            width="560"
            height="315"
            :src="news.videoUrls.replace('youtu.be', 'www.youtube.com/embed')"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          ></iframe>
        </div>
      </section>

      <section class="l-section for_tags">
        <div class="l-section-h i-cf">
          <div class="g-tags">
            <template v-for="(item, index) in news.tags">
              <router-link :key="item.tag_id" :to="{ name: 'archive', params: { id: item.tag_id } }"
              >{{ item.name }}
              </router-link>
              <template v-if="index !== news.tags.length - 1">,&nbsp;</template>
            </template>
          </div>
        </div>
      </section>

      <SharingPanel :options="shareOptions"/>

      <CardCarousel :title="$t('Останні новини')" class="_news">
        <template v-for="item in lastNews">
          <NewsCard
            :key="item.id"
            v-if="newsId !== item.id"
            :card="item"
            class="card-carousel__slide"
          />
        </template>
      </CardCarousel>

      <!--      <section class="l-section for_related">-->
      <!--        <div class="l-section-h i-cf">-->
      <!--          <h4>{{ $t("Схожа Інформація") }}</h4>-->
      <!--          <div-->
      <!--            class="w-blog layout_compact type_grid"-->
      <!--            itemscope="itemscope"-->
      <!--            itemtype="https://schema.org/Blog"-->
      <!--          >-->
      <!--            <div class="w-blog-list">-->
      <!--              <article-->
      <!--                class="w-blog-post podiyi post-6778 post type-post status-publish format-standard has-post-thumbnail hentry category-podiyi tag-hastro-vechir-v-koveli tag-mayster-klas tag-neapolitans-ka-pitsa-kovel tag-pryhotuvannia-pitsy-kovel tag-restoran-otto tag-simia-restoraniv-classic"-->
      <!--                data-id="6778"-->
      <!--                data-categories="podiyi"-->
      <!--              >-->
      <!--                <div class="w-blog-post-h">-->
      <!--                  <div class="w-blog-post-body">-->
      <!--                    <h2 class="w-blog-post-title">-->
      <!--                      <a-->
      <!--                        class="entry-title"-->
      <!--                        rel="bookmark"-->
      <!--                        href="https://classic.com.ua/podiyi/fotozvit-z-hastro-vechora/"-->
      <!--                        >Фотозвіт з гастро вечора!-->
      <!--                      </a>-->
      <!--                    </h2>-->
      <!--                    <div class="w-blog-post-meta">-->
      <!--                      <time-->
      <!--                        class="w-blog-post-meta-date date updated"-->
      <!--                        datetime="2019-12-07 17:53:44"-->
      <!--                        >07/12/2019-->
      <!--                      </time>-->
      <!--                      <span class="w-blog-post-meta-author vcard author hidden">-->
      <!--                        <a href="https://classic.com.ua/author/classic/" class="fn">Classic</a>-->
      <!--                      </span>-->
      <!--                    </div>-->
      <!--                  </div>-->
      <!--                </div>-->
      <!--              </article>-->
      <!--              <article-->
      <!--                class="w-blog-post podiyi post-7483 post type-post status-publish format-standard has-post-thumbnail hentry category-podiyi tag-classic-lounge-bar tag-den-zakohanyh tag-den-sviatoho-valentyna tag-kovel tag-restoratsiya-myaso-ta-folklor tag-simia-restoraniv-classic tag-fotozvit"-->
      <!--                data-id="7483"-->
      <!--                data-categories="podiyi"-->
      <!--              >-->
      <!--                <div class="w-blog-post-h">-->
      <!--                  <div class="w-blog-post-body">-->
      <!--                    <h2 class="w-blog-post-title">-->
      <!--                      <a-->
      <!--                        class="entry-title"-->
      <!--                        rel="bookmark"-->
      <!--                        href="https://classic.com.ua/podiyi/fotozvit-z-dnia-zakokhanykh/"-->
      <!--                        >Фотозвіт з Дня закоханих!-->
      <!--                      </a>-->
      <!--                    </h2>-->
      <!--                    <div class="w-blog-post-meta">-->
      <!--                      <time-->
      <!--                        class="w-blog-post-meta-date date updated"-->
      <!--                        datetime="2020-02-20 14:45:47"-->
      <!--                        >20/02/2020-->
      <!--                      </time>-->
      <!--                      <span class="w-blog-post-meta-author vcard author hidden">-->
      <!--                        <a href="https://classic.com.ua/author/classic/" class="fn">Classic</a>-->
      <!--                      </span>-->
      <!--                    </div>-->
      <!--                  </div>-->
      <!--                </div>-->
      <!--              </article>-->
      <!--              <article-->
      <!--                class="w-blog-post podiyi post-5776 post type-post status-publish format-standard has-post-thumbnail hentry category-podiyi tag-hastro-vechir-v-koveli tag-mayster-klas tag-pasta-vlasnoho-vyrobnytstva tag-ravioli tag-restoran-otto tag-simia-restoraniv-classic"-->
      <!--                data-id="5776"-->
      <!--                data-categories="podiyi"-->
      <!--              >-->
      <!--                <div class="w-blog-post-h">-->
      <!--                  <div class="w-blog-post-body">-->
      <!--                    <h2 class="w-blog-post-title">-->
      <!--                      <a-->
      <!--                        class="entry-title"-->
      <!--                        rel="bookmark"-->
      <!--                        href="https://classic.com.ua/podiyi/fotozvit-hastro-vechora-v-otto/"-->
      <!--                      >-->
      <!--                        Фотозвіт Гастро вечора в ОТТО !-->
      <!--                      </a>-->
      <!--                    </h2>-->
      <!--                    <div class="w-blog-post-meta">-->
      <!--                      <time-->
      <!--                        class="w-blog-post-meta-date date updated"-->
      <!--                        datetime="2019-09-02 12:45:32"-->
      <!--                        >02/09/2019-->
      <!--                      </time>-->
      <!--                      <span class="w-blog-post-meta-author vcard author hidden">-->
      <!--                        <a href="https://classic.com.ua/author/classic/" class="fn">Classic</a>-->
      <!--                      </span>-->
      <!--                    </div>-->
      <!--                  </div>-->
      <!--                </div>-->
      <!--              </article>-->
      <!--            </div>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </section>-->
    </main>
  </div>
  <ErrorView v-else/>
</template>

<script>
import CardCarousel from "@/components/CardCarousel";
import {http} from "@/axios";
import NewsCard from "../components/NewsCard";
import ErrorView from "@/components/ErrorView";
import SharingPanel from "@/components/SharingPanel";

export default {
  name: "News",
  components: {
    SharingPanel,
    ErrorView,
    NewsCard,
    CardCarousel,
  },
  data() {
    return {
      pending: false,
      news: {},
      lastNews: [],
      error: null,
    };
  },
  computed: {
    newsId() {
      return this.$route.params.newsId;
    },
    shareOptions() {
      let options = {
        url: window.location,
        text: document.title,
        image: this.news.image_m || "",
      };
      if (window.location.hostname === "localhost") {
        options.url = "http://95.216.212.103:3030" + this.$route.path;
      }
      return options;
    },
  },
  methods: {
    load() {
      this.pending = true;

      http
        .get(`api/event/event?article_id=${this.newsId}`)
        .then(({data}) => {
          this.news = data.data.event;
          this.lastNews = data.data.last_events;
        })
        .catch((error) => {
          console.log("error");
          this.error = error;
        })
        .finally(() => {
          this.pending = false;
        });
    },
    resetData() {
      this.pending = true;
      this.news = {};
      this.lastNews = [];
      this.error = null;
      window.scrollTo({
        top: 0,
      });
    },
  },
  created() {
    this.load();
  },
  beforeRouteUpdate(to, from, next) {
    this.resetData();
    next();
    this.load();
  },
};
</script>

<style></style>
